var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classPageWrapper},[(_vm.breadcrumbs && _vm.breadcrumbs.length > 0)?_c('component-navigation-breadcrumbs',{class:_vm.styleSpacer.mb24}):_vm._e(),_vm._v(" "),_c('component-typography-h1'),_vm._v(" "),(_vm.content && _vm.content.length > 0)?_c('div',{class:_vm.classWrapper},_vm._l((_vm.content),function(contentItem,index){return _c('div',{key:index},[(
          contentItem.type === 'text' &&
          contentItem.text &&
          contentItem.text.length > 0
        )?_c('div',{class:_vm.styleTypography.content,domProps:{"innerHTML":_vm._s(contentItem.text)}}):(
          contentItem.type === 'script' &&
          contentItem.code &&
          contentItem.code.length > 0
        )?_c('div',[_c('component-content-script',{attrs:{"code":contentItem.code}})],1):_vm._e()])}),0):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }